import React from 'react';
import WarningTriangleIcon from '@shared/icons/WarningTriangleIcon';
import CtaButton from '@/components/CtaButton';
import OutlineButton from '@/components/OutlineButton';
import ErrorBanner from '@/components/ErrorBanner';

/** Web·5 — the mandatory warning before disabling auto-pay. */
const TurnOffConfirmScreen = ({ schoolName, onKeep, onConfirm, busy, error }) => (
	<div className="flex flex-col items-center gap-[18px] pt-[12px]">
		<div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#fef3e2] text-[#16181d]">
			<WarningTriangleIcon width={32} height={32} />
		</div>

		<h1 className="text-center text-[24px] font-extrabold text-[#16181d]">Turn off Auto-Pay?</h1>

		<p className="text-center text-[14px] leading-[21px] text-[#7d7d7d]">
			You’ll need to pay each invoice manually after turning this off. If a payment is missed, any late fees{' '}
			{schoolName ?? 'your school'} charges would then apply.
		</p>

		<ErrorBanner>{error}</ErrorBanner>

		<div className="h-[4px]" />

		<CtaButton onClick={onKeep} disabled={busy}>
			Keep Auto-Pay on
		</CtaButton>

		<OutlineButton variant="red" onClick={onConfirm} disabled={busy}>
			{busy ? 'Turning off…' : 'Turn off Auto-Pay'}
		</OutlineButton>
	</div>
);

export default TurnOffConfirmScreen;
